<template>
  <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex flex-col w-full mt-6 gap-4" dir="ltr">
    <h3 class="dark:text-gray-100">الدرجات الإجمالية</h3>

    <canvas class="max-h-72" id="evaluations-chart" ref="evaluationsPieChart"></canvas>
  </div>
</template>

<script setup lang="ts">
import { Chart, type ChartData, type ChartTypeRegistry } from 'chart.js'
import { onMounted, ref, shallowRef, toRefs, watch } from 'vue'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import type { Evaluation } from '@/types/global'

const props = defineProps<{
  evaluations: Evaluation[]
}>()

const { evaluations } = toRefs(props)

const evaluationsPieChart = ref<HTMLCanvasElement | null>(null)

let evaluationsChart = shallowRef<
  Chart<keyof ChartTypeRegistry, (number | [number, number] | null)[], unknown> | undefined
>(undefined)

watch(evaluations, () => {
  if (evaluationsChart.value) {
    evaluationsChart.value.data = getOverallDegreeDistribution(evaluations.value)
    evaluationsChart.value.update()
  }
})

function getOverallDegreeDistribution(evaluations: Evaluation[]): ChartData<'bar'> {
  let totalMemorize = 0
  let totalReview = 0
  let totalEnsure = 0

  // Aggregate values
  evaluations.forEach((ev) => {
    totalMemorize += ev.degree_memorize ? parseFloat(ev.degree_memorize) : 0
    totalReview += ev.degree_review ? parseFloat(ev.degree_review) : 0
    totalEnsure += ev.degree_ensure ? parseFloat(ev.degree_ensure) : 0
  })

  return {
    labels: ['الدرجات الإجمالية'],
    datasets: [
      {
        label: 'الحفظ',
        data: [totalMemorize],
        backgroundColor: 'rgba(75, 192, 192, 0.8)'
      },
      {
        label: 'المراجعة',
        data: [totalReview],
        backgroundColor: 'rgba(255, 159, 64, 0.8)'
      },
      {
        label: 'التثبيت',
        data: [totalEnsure],
        backgroundColor: 'rgba(153, 102, 255, 0.8)'
      }
    ]
  }
}

onMounted(() => {
  if (evaluationsPieChart.value) {
    evaluationsChart.value = new Chart(evaluationsPieChart.value, {
      type: 'bar',
      plugins: [ChartDataLabels],
      options: {
        responsive: true
      },
      data: getOverallDegreeDistribution(evaluations.value)
    })
  }
})
</script>

<style scoped></style>
